// extracted by mini-css-extract-plugin
export default {"menuToggle":"tCoR8j","toggleOpen":"jBAR_t","buttonContainer":"oCWBCl","menu-icon":"XcYkhL","menuIcon":"XcYkhL"};